module.exports = __webpack_public_path__ + "static/media/logo.8e283c70.png";


//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/src/resources/images/logo.png
// module id = 698
// module chunks = 0